import moment from 'moment';

export const simpleDateFormatter = date => moment(date).format('DD-MM-YYYY');
